export default function FinalCTA() {
  return (
    <section className="relative w-full h-screen min-h-[500px] overflow-hidden">
      {/* Background */}
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=A%20bright%20airy%20creative%20studio%20space%20with%20a%20large%20wooden%20table%20covered%20in%20product%20samples%20fabric%20swatches%20and%20a%20tablet%20showing%20data%2C%20sunlight%20pouring%20through%20floor-to-ceiling%20windows%2C%20indoor%20plants%20scattered%20around%2C%20modern%20minimalist%20aesthetic%2C%20warm%20golden%20hour%20glow%2C%20aspirational%20workspace%20photography&width=1800&height=1200&seq=cta-v2-final-2026&orientation=landscape"
          alt="Start sourcing smarter with ItaobuySpreadsheet"
          title="ItaobuySpreadsheet - Start Sourcing Smarter Today"
          className="w-full h-full object-cover"
        />
      </div>
      <div className="absolute inset-0 bg-gradient-to-b from-black/30 via-black/25 to-black/40"></div>

      {/* Content */}
      <div className="relative z-10 h-full flex flex-col items-center justify-center px-4 text-center">
        <h2 className="font-heading text-4xl md:text-6xl lg:text-7xl text-background-50 font-bold tracking-wide leading-[1.1] max-w-3xl">
          START SOURCING SMARTER
        </h2>
        <p className="mt-6 text-sm md:text-base text-background-50/80 max-w-lg leading-relaxed">
          Join thousands using itaobuyspreadsheet to find winning products faster.
        </p>
        <div className="mt-10">
          <a
            href="https://kaspreadsheet.com"
            target="_blank"
            rel="noopener nofollow"
            className="inline-flex items-center gap-3 px-8 py-4 text-base font-semibold bg-accent-500 text-background-50 rounded-full hover:bg-accent-600 smooth-transition whitespace-nowrap cursor-pointer"
          >
            <span className="w-6 h-6 rounded-full bg-background-50/20 flex items-center justify-center flex-shrink-0">
              <i className="ri-shopping-bag-line text-background-50 text-sm"></i>
            </span>
            BUY IT NOW
            <i className="ri-arrow-right-up-line text-lg"></i>
          </a>
        </div>
      </div>
    </section>
  );
}